import { useTranslation } from 'react-i18next'
import { EntityPageHeader } from '@/shared/components'
import { PeriodeList } from '../components'

export function PeriodesListPage() {
  const { t } = useTranslation()

  return (
    <div>
      <EntityPageHeader
        title={t('administration.sections.periods.pageTitle', 'Gestion des Périodes')}
        backTo="/administration"
        createTo="/administration/periodes/create"
        createLabel={t('administration.sections.periods.createButton', 'Créer une période')}
      />
      <PeriodeList />
    </div>
  )
}
